import { types } from "mobx-state-tree";

export enum ModalType {
  Login = "Login",
}

const modalTypes = Object.values(ModalType);

export const PageStore = types
  .model("PageStore", {
    currentModal: types.maybe(types.enumeration(modalTypes)),
    loginRedirectUrl: types.maybe(types.string),
  })
  .actions((self) => ({
    openModal(modalType: ModalType) {
      self.currentModal = modalType;
    },
    closeModal() {
      self.currentModal = undefined;
      self.loginRedirectUrl = undefined;
    },
    setLoginRedirectUrl(url: string | undefined) {
      self.loginRedirectUrl = url;
    },
    clearLoginRedirectUrl() {
      self.loginRedirectUrl = undefined;
    },
  }))
  .views((self) => ({
    isLoginModalOpen: () => self.currentModal === ModalType.Login,
  }));

export const createPageStore = () => {
  return PageStore.create({});
};
